<div>
    <div class="modal-dialog modal-dialog-centered">

        <div class="modal-content">

            <div class="modal-header">

                <h2 class="modal-title"> بررسی اطلاعات مالک شناور </h2>

            </div>

            <div class="modal-body">

                <div class="form-group has-icon" [ngClass]="strMobileField.value ? 'direction-ltr' : ''">

                    <span class="form-control-icon">

                        <mat-icon>phone_iphone</mat-icon>

                    </span>

                    <input type="search" class="form-control" [disabled]="isSubmitDisabled" #strMobileField="ngModel"
                        [(ngModel)]="strMobile" required appPhoneNumberValidation [maxLength]="11" [minlength]="11"
                        placeholder="شماره موبایل" inputmode="numeric"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'')" (keydown.enter)="submit(strMobileField)"
                        autofocus />

                    <ng-container *ngIf="strMobileField.invalid && strMobileField.touched">

                        <small class="text-danger"> شماره موبایل را به درستی وارد کنید </small>

                    </ng-container>

                </div>
            </div>

            <div class="modal-footer d-flex flex-row-reverse justify-content-end">

                <button type="button" class="btn btn-primary"
                    [disabled]="strMobileField.invalid || strMobileField.pristine || isSubmitDisabled"
                    (click)="submit(strMobileField)"> بررسی موبایل </button>

            </div>

        </div>

    </div>

</div>

<!-- Dtails Dialog -->
<ng-template #detailsDialogTemplate let-modal>
    <ng-container>
        <div class="modal-header">
            <h2 class="modal-title">نمایش اطلاعات</h2>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.close()"></button>
        </div>
        <div class="modal-body" [formGroup]="formGroup">
            <div class="grid-container">
                <div class="field-wrapper">
                    <label for="name-field">نام</label>
                    <input type="text" class="form-control" readonly id="name-field"
                        [value]="tankerProfile.strName || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="family-field">نام خانوادگی</label>
                    <input type="text" class="form-control" readonly id="family-field"
                        [value]="tankerProfile.strFamily || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="national-id-field">کد‌ملی مالک تانکر</label>
                    <input type="text" class="form-control direction-ltr" readonly id="national-id-field"
                        [value]="tankerProfile.strID || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="mobile-field">موبایل</label>
                    <input type="text" class="form-control direction-ltr" readonly id="mobile-field"
                        [value]="tankerProfile.strMobile || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="city-field">شهر</label>
                    <input type="text" class="form-control" readonly id="city-field"
                        [value]="tankerProfile.strCityName || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="state-field">آدرس</label>
                    <input type="text" class="form-control" readonly id="state-field"
                        [value]="tankerProfile.strAddress || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="date-field">تاریخ ثبت</label>
                    <input type="text" class="form-control direction-ltr" readonly id="date-field"
                        [value]="tankerProfile.strRegisterDateTime || '-'">
                </div>
                <div class="field-wrapper">
                    <label for="tracking-code-field">شماره پیگیری فیش پرداختی</label>
                    <input class="form-control direction-ltr" formControlName="iTrackingCode" inputmode="numeric"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'')" id="tracking-code-field">
                </div>
                <div class="field-wrapper ">
                    <label for="iPayment1-field">مبلغ واریزی (ریال)</label>
                    <input class="form-control direction-ltr" formControlName="iPayment1" inputmode="numeric"
                        oninput="this.value=this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        id="iPayment1-field">
                </div>
                <div class="d-none field-wrapper form-check form-switch d-flex align-items-center">
                    <input class="form-check-input m-0" type="checkbox" id="bInstallment"
                        formControlName="bInstallment">
                    <label class="form-check-label pointer text-muted me-2" for="bInstallment">پرداخت اقساطی</label>
                </div>
                <div class="field-wrapper textarea">
                    <div *ngIf="formGroup.get('bInstallment')?.value" class="form-group has-icon">
                        <span class="form-control-icon">
                            <mat-icon>description</mat-icon>
                        </span>
                        <textarea class="form-control" formControlName="strPaymentComment"
                            placeholder="توضیحات شرایط پرداخت ..."></textarea>
                    </div>
                </div>
                <div *ngIf="formGroup.get('bCanEdit')?.value" class="field-wrapper">
                    <button class="btn btn-primary" (click)="submitForm()">ویرایش</button>
                </div>
            </div>
        </div>
    </ng-container>
</ng-template>